import React from 'react';
import './Blog.css';
import criminal_law_blog from '../assets/criminal_law_blog.webp';

const Blog = () => {
  return (
    <div className="blog-page">
      <div className="container">
        <h1>Legal Blog</h1>
        
        <section className="blog-intro">
          <img 
            src="https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&h=400&fit=crop" 
            alt="Legal books and gavel" 
            className="intro-image"
          />
          <p>
            Stay updated with the latest legal developments, insights, and analysis from our team of experts. 
            Our blog covers various aspects of law, recent judgments, and practical legal guidance.
          </p>
        </section>

        <section className="blog-posts">
          <article className="blog-post">
            <img 
              src="https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=400&h=250&fit=crop" 
              alt="Property documents" 
              className="post-image"
            />
            <h2>Understanding Your Rights in Property Disputes</h2>
            <div className="post-meta">
              <span className="date">January 15, 2024</span>
              <span className="category">Property Law</span>
            </div>
            <p>
              Property disputes are among the most common legal issues faced by individuals and businesses. 
              This comprehensive guide explains your rights and the legal remedies available...
            </p>
            <button className="read-more">Read More</button>
          </article>

          <article className="blog-post">
            <img 
              src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=400&h=250&fit=crop" 
              alt="Corporate meeting" 
              className="post-image"
            />
            <h2>Recent Changes in Corporate Compliance Requirements</h2>
            <div className="post-meta">
              <span className="date">January 10, 2024</span>
              <span className="category">Corporate Law</span>
            </div>
            <p>
              The Ministry of Corporate Affairs has introduced several amendments to compliance requirements. 
              Companies need to be aware of these changes to ensure proper adherence...
            </p>
            <button className="read-more">Read More</button>
          </article>

          <article className="blog-post">
            <img 
              src="https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?w=400&h=250&fit=crop" 
              alt="Family consultation" 
              className="post-image"
            />
            <h2>Family Court Procedures: A Step-by-Step Guide</h2>
            <div className="post-meta">
              <span className="date">January 5, 2024</span>
              <span className="category">Family Law</span>
            </div>
            <p>
              Navigating family court procedures can be overwhelming. This guide provides a clear understanding 
              of the process, required documentation, and what to expect during proceedings...
            </p>
            <button className="read-more">Read More</button>
          </article>

          <article className="blog-post">
            <img 
              src={criminal_law_blog}
              alt="Supreme Court building" 
              className="post-image"
            />
            <h2>Criminal Law Updates: Recent Supreme Court Judgments</h2>
            <div className="post-meta">
              <span className="date">December 28, 2023</span>
              <span className="category">Criminal Law</span>
            </div>
            <p>
              The Supreme Court has delivered several landmark judgments in criminal law matters. 
              These decisions have significant implications for legal practice and individual rights...
            </p>
            <button className="read-more">Read More</button>
          </article>

          <article className="blog-post">
            <img 
              src="https://images.unsplash.com/photo-1556155092-490a1ba16284?w=400&h=250&fit=crop" 
              alt="Business documents" 
              className="post-image"
            />
            <h2>Essential Legal Documents for Small Businesses</h2>
            <div className="post-meta">
              <span className="date">December 20, 2023</span>
              <span className="category">Business Law</span>
            </div>
            <p>
              Starting a small business requires proper legal documentation. This article outlines 
              the essential legal documents every entrepreneur should have in place...
            </p>
            <button className="read-more">Read More</button>
          </article>

          <article className="blog-post">
            <img 
              src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=250&fit=crop" 
              alt="Intellectual property concept" 
              className="post-image"
            />
            <h2>Understanding Intellectual Property Rights in India</h2>
            <div className="post-meta">
              <span className="date">December 15, 2023</span>
              <span className="category">IP Law</span>
            </div>
            <p>
              Intellectual property protection is crucial in today's knowledge economy. 
              Learn about different types of IP rights and how to protect your innovations...
            </p>
            <button className="read-more">Read More</button>
          </article>
        </section>

        {/* <section className="blog-categories">
          <h2>Categories</h2>
          <div className="categories-list">
            <button className="category-tag">All Posts</button>
            <button className="category-tag">Civil Law</button>
            <button className="category-tag">Criminal Law</button>
            <button className="category-tag">Corporate Law</button>
            <button className="category-tag">Family Law</button>
            <button className="category-tag">Property Law</button>
            <button className="category-tag">IP Law</button>
            <button className="category-tag">Business Law</button>
          </div>
        </section>

        <section className="newsletter-signup">
          <h2>Stay Updated</h2>
          <p>Subscribe to our newsletter to receive the latest legal insights and updates directly in your inbox.</p>
          <div className="newsletter-form">
            <input type="email" placeholder="Enter your email address" />
            <button className="subscribe-button">Subscribe</button>
          </div>
        </section> */}
      </div>
    </div>
  );
};

export default Blog;
